import PropTypes from 'prop-types'
import { XCircle } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import { APP_COLORS } from '../../helpers/constants'

const ErrorScreen = ({ onDone }) => {
  const { t } = useTranslation(['package-room'])
  return (
    <div className="package-room__content package-room__content--full">
      <div className="package-room__access-container package-room__access-container--unlocked">
        <div className="package-room__icon">
          <XCircle size={64} color={APP_COLORS.black300} weight="regular" />
        </div>

        <h2 className="package-room__title package-room__title--unlocked">
          {t('package-room:errorScreen.title')}
        </h2>

        <div className="package-room__unlocked-message">
          <p>{t('package-room:errorScreen.message')}</p>
        </div>
      </div>

      <div className="package-room__action-buttons">
        <button className="package-room__submit-button" onClick={onDone}>
          {t('package-room:errorScreen.reset')}
        </button>
      </div>
    </div>
  )
}

ErrorScreen.propTypes = {
  onDone: PropTypes.func.isRequired,
}

export default ErrorScreen
